import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Paper, Tabs, Tab } from '@material-ui/core';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { DOCUMENTS_PANEL } from 'containers/ManagerDocumentsPage/constants';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerDocumentsPage/messages';
import DocumentsToValidate from 'containers/LawyerDocumentsPage/DocumentsToValidate';
import ValidatedDocuments from 'containers/LawyerDocumentsPage/ValidatedDocuments';
import RejectedDocuments from 'containers/LawyerDocumentsPage/RejectedDocuments';
import { requestExistantClaimsForLawter } from 'containers/LawyerDocumentsPage/action';
import { makeSelectExistantClaims } from 'containers/ManagerDocumentsPage/selectors';
import { get } from 'lodash';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export interface LawyerDocumentsPageProps {
  intl: IntlShape;
  existantClaims: any;
  requestExistantClaimsForLawter: Function;
  keyclokToken: string;
}

const Container = styled(Paper)`
  margin-top: 50px;
  .MuiTabs-flexContainer {
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .MuiTab-root {
  }
`;

const LawyerDocumentsPage: React.FC<LawyerDocumentsPageProps> = (
  props,
): JSX.Element => {
  const [tab, setTab] = React.useState(DOCUMENTS_PANEL.PENDING_VALIDATION);

  const handleChange = (event: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
  };
  return (
    <Container square>
      <Tabs
        value={tab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        className="tab-container"
      >
        <Tab label={translate(messages.pendingDocumentsTabTitle, props)} />
        <Tab label={translate(messages.validatedDocumentsTabTitle, props)} />
        <Tab label={translate(messages.rejectedDocumentsTabTitle, props)} />
      </Tabs>
      {tab === DOCUMENTS_PANEL.PENDING_VALIDATION && (
        <DocumentsToValidate
          existantClaims={get(props.existantClaims, 'result', [])}
          requestExistantClaims={props.requestExistantClaimsForLawter}
          keyclokToken={props.keyclokToken}
        />
      )}
      {tab === DOCUMENTS_PANEL.VALIDATED && (
        <ValidatedDocuments
          existantClaims={get(props.existantClaims, 'result', [])}
          requestExistantClaims={props.requestExistantClaimsForLawter}
          keyclokToken={props.keyclokToken}
        />
      )}
      {tab === DOCUMENTS_PANEL.REJECTED && (
        <RejectedDocuments
          existantClaims={get(props.existantClaims, 'result', [])}
          requestExistantClaims={props.requestExistantClaimsForLawter}
          keyclokToken={props.keyclokToken}
        />
      )}
    </Container>
  );
};
const mapDispatchToProps = {
  requestExistantClaimsForLawter,
};

const mapStateToProps = createStructuredSelector({
  existantClaims: makeSelectExistantClaims(),
  keyclokToken: makeSelectKeycloakToken(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LawyerDocumentsPage));
